import './utils-module'

// filtros
import './filters/cpfCnpjFilters'

// serviços
import './services/cacheService'
import './services/serverAddress'
import './services/loggedUserService'
import './services/fileUtilsService'
import './services/reportsService'
import './services/geoDBService'
import './services/sidebarService'
import './services/localSettingsService'
import './services/printerService'
import './services/loaderService'
import './services/blockService'
import './services/parameterService'
import './services/thermOfUseAdherenceService'
import './services/orderTypeService'
import './services/rolesService'
import './services/clientService'
import './services/cpfCnpjService'
import './services/idhaApiErrorService'
import './services/addressService'


// dados compartilhados
import './sharedData/productList'
import './sharedData/ordersFilters'
import './sharedData/currentOrderType'
import './sharedData/currentTags'

// interceptadores

import './interceptors/appVersionInterceptor'
import './interceptors/ownerIdHttpInterceptor'
import './interceptors/authErrorInterceptor'

// controllers
import './controllers/mainMenuController'
import './controllers/mainController'
import './controllers/rightMenuController'

// diretivas

import './directive/cpfCnpj'

// componentes
import './components/country-selector/country-selector.component'
import './components/postal-code-input/postal-code-input.component'
import './components/city-selector/city-selector.component'
import './components/state-selector/state-selector.component'
import './components/password-input/password-input.component'
import './components/login-register/login-register.component'
import './components/password-reset/password-reset.component'
import './components/password-reset/password-reset-confirm-page.component'
import './components/confirm-email-phone/confirm-email-phone.component'

import './react2angular/index'

export * from './interceptors'
export * from './hooks'
export * from './reactComponents'
export * from './orders'
